// Pure gating logic for editing a saved draft quote in OrderConfirmation.
// Kept side-effect free so it can be unit tested in isolation.
//
//   quoteEditUnlocked - user is actively editing a saved draft quote
//   gridReadOnly       - material/labor grid inputs + actions are locked
//   allowLocalMerge    - localStorage-selected items may be merged into the grid
export function deriveQuoteEditFlags({ isDraftQuote, isEditingQuote, checkOrder, isQuality }) {
  const quoteEditUnlocked = Boolean(isDraftQuote && isEditingQuote);
  const gridReadOnly = Boolean(checkOrder && !quoteEditUnlocked);
  const allowLocalMerge = Boolean(isQuality || !checkOrder || quoteEditUnlocked);
  return { quoteEditUnlocked, gridReadOnly, allowLocalMerge };
}
